module.exports = __webpack_public_path__ + "assets/administration.4e72fb90.svg";